export default __webpack_public_path__ + "static/media/3.26ee26f2.webp";